import {mapActions, mapGetters, mapMutations} from 'vuex';
import {seo} from '@/mixins/seo'

export default {
    name: 'tests-rules',
    mixins: [seo],
    created() {
        this.seo.title = this.$t('testRulesLabel')
        this.changeHeader({
            show: true,
            title: this.$t('testRulesLabel'),
            parentRoute: 'tests'
        })
        if (!this.currentItem) {
            this.fetchData({
                testId: this.$route.params.testId
            }).then(() => {
                this.checkStatusTest()
                this.setSeo()
            }).catch(error => {
                if (error.response.status === 403) {
                    // this.$toasted.error(error.response.data.error.message_key)
                    try {
                        this.$router.push({name: 'tests'})
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
        } else {
            this.checkStatusTest()
            this.setSeo()
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!to.path.includes(`tests/${this.$route.params.testId}`)) {
            this.setItem(null)
        }
        next()
    },
    computed: {
        ...mapGetters({
            isLoading: 'tests/isLoading',
            currentItem: 'tests/currentItem',
            isAuthenticated: 'auth/isAuthenticated',
        }),
        convertSecondsToMinutes() {
            return Math.ceil(this.currentItem.availableTime / 60)
        }
    },
    methods: {
        ...mapActions({
            fetchData: 'tests/GET_LIST_ITEM',
        }),
        ...mapMutations({
            changeHeader: 'tests/CHANGE_HEADER',
            setItem: 'tests/SET_ITEM',
            setQuestion: 'tests/SET_CURRENT_QUESTION',
            setReportResult: 'tests/SET_REPORT_RESULT',
        }),
        declensionWordModule(count, type) {
            let titles = [this.$t(`${type}1`), this.$t(`${type}2`), this.$t(`${type}3`)];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        start(param) {
            this.$router.push({name: `tests-${param}`, params: {testId: this.$route.params.testId}})
        },
        setSeo() {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        },
        checkStatusTest() {
            if (this.currentItem.userTest.data.hasOwnProperty('status')) {
                switch (this.currentItem.userTest.data.status) {
                    case 'in_process': {

                        break;
                    }
                    case 'new': {

                        break;
                    }
                    case 'canceled': {

                        break;
                    }
                    case 'completed': {
                        try {
                            this.$router.push({name: 'tests-check', params: {testId: this.$route.params.testId}})
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                    default: {
                        try {
                            this.$router.push({name: 'tests-report', params: {testId: this.$route.params.testId}})
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                }
            }
        }
    },
    destroyed() {
        this.setQuestion(null)
        this.setReportResult(null)
    }
}
